import { render } from "./LayoutItem.vue?vue&type=template&id=0bdefd1d&scoped=true&ts=true&lang=pug"
import script from "./LayoutItem.vue?vue&type=script&lang=ts"
export * from "./LayoutItem.vue?vue&type=script&lang=ts"

import "./LayoutItem.vue?vue&type=style&index=0&id=0bdefd1d&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdefd1d"]])

export default __exports__